export enum TaskServiceRunType {
  Recurring
}